import { useEffect, useState } from 'react';
import { useDepsMatchingCallbackRef } from 'src/utils/react/deps-matching-callback-ref.hook';
import { apiGetJourneyInsightsByContent } from 'src/utils/journeyApi';
import { TimePeriodParam } from '../constants';

type Params = {
  journeyUuId?: string;
  filters?: {
    session_uuid?: string;
    disable_session_grouping?: boolean;
    time_period?: TimePeriodParam;
  };
};

type StepInsight = {
  journey_id: number;
  node_id: number;
  total_time: number;
  num_sessions: number;
  num_journey_sessions: number;
};

export const useJourneyInsightsByStep = ({ journeyUuId, filters }: Params) => {
  const [fetching, setFetching] = useState(true);
  const [stepInsights, setStepInsights] = useState<StepInsight[]>([]);

  const onFetchJourneyInsightsRef = useDepsMatchingCallbackRef(
    (response: any) => {
      setStepInsights(response.insights as StepInsight[]);
      setFetching(false);
    },
    [journeyUuId, filters]
  );

  useEffect(() => {
    const fetchStepInsights = async () => {
      setFetching(true);
      if (journeyUuId) {
        const response = await apiGetJourneyInsightsByContent(
          journeyUuId,
          // @ts-ignore
          filters?.session_uuid || undefined,
          filters?.disable_session_grouping || false,
          filters?.time_period || undefined
        );
        onFetchJourneyInsightsRef.current && onFetchJourneyInsightsRef.current(response, [journeyUuId, filters]);
      }
    };
    fetchStepInsights();
  }, [journeyUuId, filters]);

  return { fetching, stepInsights };
};
